<template>
    <div class="reg-temp-content-area main-content-height p-5">
        <div class="superadmin-dashboard-area edit-area">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="registered-product-item w-half">
                                <router-link :to="{name: 'SuperadminRegisteredProducts'}" class="mb-3 inline-block"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                                >
                                <h3 class="mb-4">Add product</h3>
                                <ul>
                                    <serial-and-model :data="form" />
                                    <li>
                                        <span class="semibold">Date purchased</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                class="input"
                                                id="cdate"
                                                :format="'yyyy-MM-dd'"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="purchaseDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Installation date</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="installationDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <!-- <li>place of purchase: <span><input type="text" v-model="form.place_of_purchase" name="placeof_purchase" class="form-control" placeholder="Place Of Purchase"/></span></li> -->
                                    <li class="border-b-1">
                                        <file-uploader label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>

                                    <li>
                                        <span class="semibold mb-2">Installation status</span>
                                        <span class="coc-radio d-flex flex-column cursor-pointer">
                                            <label class="mr-2 font-normal" for="with_coc">
                                                <input
                                                    id="with_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="with_coc"
                                                />
                                                Installed with COC
                                            </label>
                                            <label class="mr-2 font-normal" for="without_coc">
                                                <input
                                                    id="without_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="without_coc"
                                                />
                                                Installation delayed
                                            </label>
                                            <label class="mr-2 font-normal" for="no_coc">
                                                <input
                                                    id="no_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="no_coc"
                                                />
                                                No coc
                                            </label>
                                        </span>
                                    </li>

                                    <ul class="border-b-1" v-show="form.installation_compliance == 'with_coc'">
                                        <li>
                                            <span class="semibold">Coc number</span>
                                            <span>
                                                <input
                                                    type="text"
                                                    v-model="form.coc_number"
                                                    name="coc_number"
                                                    class="form-control"
                                                    placeholder="Coc number"
                                            /></span>
                                        </li>
                                        <li class="mb-0">
                                            <file-uploader label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                        </li>
                                    </ul>
                                    <li class="mb-4 mt-4">
                                        <span class="semibold">Select depo</span>
                                        <span>
                                            <select v-model="form.distributor_id" class="baseline-input">
                                                <option value="">--Select--</option>
                                                <option :value="distributor.id" v-bind:key="distributor.id" v-for="distributor in depos">
                                                    {{ distributor.company }}
                                                </option>
                                            </select>
                                        </span>
                                    </li>

                                    <li class="mb-4">
                                        <span class="semibold">Select reseller</span>
                                        <span>
                                            <vue-autosuggest
                                                :suggestions="resellerSuggestions"
                                                :input-props="{
                                                    class: 'form-control',
                                                    id: 'autosuggest_preseller_input',
                                                    placeholder: 'Search reseller'
                                                }"
                                                @input="onChangeResellerInput"
                                                @selected="selectResellerHandler"
                                                @click="onChangeResellerInput"
                                                :getSuggestionValue="resellerSuggestionsValue"
                                            >
                                                <template slot-scope="{suggestion}">
                                                    <span class="my-suggestion-item">{{
                                                        suggestion.item.company ? suggestion.item.company : suggestion.item.email
                                                    }}</span>
                                                </template>
                                            </vue-autosuggest>
                                        </span>
                                    </li>

                                    <li class="mb-4">
                                        <span class="semibold">Select customer</span>
                                        <span>
                                            <vue-autosuggest
                                                :suggestions="customerSuggestions"
                                                :input-props="{
                                                    class: 'form-control',
                                                    id: 'autosuggest_pcustomer_input',
                                                    placeholder: 'Search customer'
                                                }"
                                                @input="onChangeCustomerInput"
                                                @selected="selectCustomerHandler"
                                                @click="onChangeCustomerInput"
                                                :getSuggestionValue="customerSuggestionsValue"
                                            >
                                                <template slot-scope="{suggestion}">
                                                    <span class="my-suggestion-item">{{ suggestion.item.fname + ' ' + suggestion.item.lname }}</span>
                                                </template>
                                            </vue-autosuggest>
                                        </span>
                                    </li>
                                </ul>
                                <button class="btn btn-secondary with-white-border px-5 btn-rounded" @click.prevent="addNewRegProduct()">
                                    + ADD
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VueAutosuggest} from 'vue-autosuggest';
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Helpers from '@/helpers/index';
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';

export default {
    name: 'addRegProduct',
    components: {
        VueAutosuggest
    },

    data() {
        return {
            serial_number_max_length: 6,
            customerSuggestions: [
                {
                    data: []
                }
            ],

            resellerSuggestions: [
                {
                    data: []
                }
            ],

            depos: [],

            form: {
                distributor_id: '',
                reseller_id: '',
                customer_id: '',

                product_model: '',
                // customer: {},
                // customer_id: '',
                serial_number: '',
                sku_number: '',
                order_number: '',
                sku_with_serial_number: '',
                date_of_purchase: '',
                installation_date: '',
                // place_of_purchase: '',
                installation_compliance: 'with_coc',
                coc_number: '',
                invoice_number: '',
                coc_certificate: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },
                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                }
            }
        };
    },
    watch: {
        // 'form.date_of_purchase': {
        //     handler(newVal) {
        //         if (this.form.installation_date && newVal && this.form.installation_date < newVal) {
        //             this.form.installation_date = null;
        //         } else if (this.form.installation_date && !newVal) {
        //             this.form.installation_date = null;
        //         }
        //     },
        //     deep: true
        // },
        // 'form.installation_date': {
        //     handler(newVal) {
        //         if (this.form.date_of_purchase && newVal && this.form.date_of_purchase > newVal) {
        //             this.form.date_of_purchase = null;
        //         } else if (this.form.date_of_purchase && !newVal) {
        //             this.form.date_of_purchase = null;
        //         }
        //     },
        //     deep: true
        // }
    },
    computed: {
        purchaseDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.installation_date) {
                const dayAfterInstall = new Date(this.form.installation_date);
                dayAfterInstall.setDate(dayAfterInstall.getDate());
                disabled.from = dayAfterInstall;
            }
            return disabled;
        },
        installationDisabledDates() {
            let disabled = {from: new Date()};

            if (this.form.date_of_purchase) {
                const dayBeforePurchase = new Date(this.form.date_of_purchase);
                dayBeforePurchase.setDate(dayBeforePurchase.getDate());
                disabled.to = dayBeforePurchase;
            }
            return disabled;
        }
    },

    mounted() {
        this.fetchDistributor();
    },

    methods: {
        /**
         * Fetch distributors
         */
        fetchDistributor() {
            const url = `${Env.baseUrl}/get-distributors`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.depos = res.data.payload;
                })
                .catch((err) => {
                    this.depos = [];
                });
        },

        /**
         * Register new product
         */
        async addNewRegProduct() {
            this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
            this.form.installation_date = this.form.installation_date ? moment(this.form.installation_date).format('YYYY-MM-DD') : '';
            this.form.date_of_purchase = this.form.date_of_purchase ? moment(this.form.date_of_purchase).format('YYYY-MM-DD') : '';
            if (this.form.date_of_purchase && this.form.installation_date && this.form.installation_date < this.form.date_of_purchase) {
                return this.$toasted.global.error({
                    message: 'Installation date cannot be before date of purchase.'
                });
            }

            // pass data as form data
            let formData = new FormData();
            for (let key in this.form) {
                if (key != 'coc_certificate' && key != 'proof_of_purchase') {
                    formData.append(key, this.form[key]);
                }
            }

            if (this.form.coc_certificate.file && this.form.installation_compliance == 'with_coc') {
                formData.append('coc_certificate', this.form.coc_certificate.file);
            }

            if (this.form.proof_of_purchase.file) {
                formData.append('proof_of_purchase', this.form.proof_of_purchase.file);
            }

            this.spinner(true);
            const url = `${Env.baseUrl}/superadmin/reg-product/create`;
            AuthApis.postApi(url, formData)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: res.data.message
                    });
                    // then return to list page
                    this.$router.push({name: 'SuperadminRegisteredProducts'});
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                });
        },

        /**
         * Customer autocomplete
         */

        customerSuggestionsValue(obj) {
            return obj.item.fname + ' ' + obj.item.lname;
        },

        onChangeCustomerInput: _.debounce(function (name) {
            if (name == null) {
                name = document.getElementById('autosuggest_pcustomer_input').value;
            }

            const url = `${Env.baseUrl}/superadmin/users/suggest-all?role=customer`;
            AuthApis.postApi(url, {
                name: name
            })
                .then((res) => {
                    this.customerSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 1000),

        // onChangeCustomerInput(name) {
        //   // this.form.customer = '';
        //   const url = `${Env.baseUrl}/superadmin/users/suggest-all?role=customer`;
        //   AuthApis.postApi(url, {
        //     name: name
        //   }).then(res => {
        //     this.customerSuggestions[0].data = res.data.payload;
        //   }).catch(err => {
        //     console.log(err)
        //   })
        // },

        selectCustomerHandler(obj) {
            this.form.customer_id = obj.item.id;
        },

        /**
         * reseller autocomplete
         */
        resellerSuggestionsValue(obj) {
            return obj.item.company ? obj.item.company : obj.item.email;
        },

        /**
         *
         * On change serach reftch suggest
         */
        onChangeResellerInput: _.debounce(function (name) {
            if (name == null) {
                name = document.getElementById('autosuggest_preseller_input').value;
            }

            const url = `${Env.baseUrl}/superadmin/users/suggest-all?role=reseller`;
            AuthApis.postApi(url, {
                name: name
            })
                .then((res) => {
                    this.resellerSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 1000),

        selectResellerHandler(obj) {
            this.form.reseller_id = obj.item.id;
        }
    }
};
</script>
